var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c("map-component", [_c("search-bar-component")], 1),
      _vm._v(" "),
      _c("info-panel-component"),
      _vm._v(" "),
      _c("metadata-component"),
      _vm._v(" "),
      _c("facet-search-component")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }